import { getAllMedicine } from "../services/medicineNewService";

const getMedicineDisplayName = (medicine) => {
  if (!medicine || typeof medicine !== "object") return "";
  return String(
    medicine.name || medicine.medicineName || medicine.medicine_name || ""
  ).trim();
};

const getMedicineCatalogId = (medicine) =>
  medicine?.medicineId ?? medicine?.medicine_id ?? medicine?.id ?? null;

const prescriptionMedicinesNeedNameEnrichment = (prescriptions) =>
  Array.isArray(prescriptions) &&
  prescriptions.some(
    (prescription) =>
      Array.isArray(prescription?.medicines) &&
      prescription.medicines.some((medicine) => {
        const id = getMedicineCatalogId(medicine);
        return id != null && !getMedicineDisplayName(medicine);
      })
  );

const buildMedicineNameLookup = (catalog = []) => {
  const nameById = new Map();
  (Array.isArray(catalog) ? catalog : []).forEach((medicine) => {
    const id = getMedicineCatalogId(medicine);
    const name = getMedicineDisplayName(medicine);
    if (id == null || !name) return;
    nameById.set(String(id), name);
  });
  return nameById;
};

export const enrichPrescriptionMedicinesWithNames = async (prescriptions) => {
  if (!prescriptionMedicinesNeedNameEnrichment(prescriptions)) {
    return prescriptions;
  }

  let catalog = [];
  try {
    catalog = await getAllMedicine();
  } catch (error) {
    console.warn(
      "[prescriptionMedicineUtils] Failed to load medicine catalog for name enrichment:",
      error
    );
    return prescriptions;
  }

  const nameById = buildMedicineNameLookup(catalog);
  if (!nameById.size) return prescriptions;

  return prescriptions.map((prescription) => {
    if (!Array.isArray(prescription?.medicines)) return prescription;

    const medicines = prescription.medicines.map((medicine) => {
      if (getMedicineDisplayName(medicine)) return medicine;

      const medicineId = getMedicineCatalogId(medicine);
      const resolvedName =
        medicineId != null ? nameById.get(String(medicineId)) : null;
      if (!resolvedName) return medicine;

      return {
        ...medicine,
        name: resolvedName,
        medicineName: medicine.medicineName || resolvedName,
      };
    });

    return { ...prescription, medicines };
  });
};
